<template>
  <div class="nl__bg" v-if="false">
    <div class="nl__modal">
      <div class="nl__top free">
        <div class="nl__number"><span>3</span></div>
        <div class="nl__textinfo">
          <p class="nl__name free">3-й Уровень!</p>
          <p class="nl__description">Поздравляем, ты достиг 2-го уровня, собирай баллы и получай бонусы.</p>
          <p class="nl__abilities__prelude">Теперь тебе доступно:</p>
          <ul class="nl__abilities">
            <li class="nl__ability">Апгрейд попкорна</li>
            <li class="nl__ability">Персональные 3D очки</li>
          </ul>
        </div>
        <div class="popup__progress">
          <div class="popup__progress__top">
            <p class="popup__progress__currentlvl">2 Уровень</p>
            <p class="popup__progress__lvlprogress"><span>20</span> / 40 баллов</p>
          </div>
          <div class="popup__progress__bar__container">
            <div class="popup__progress__bar"></div>
          </div>
        </div>
        <div class="conf__dot nl__conf nl__conf__1"></div> 
        <img src="/static/img/gus_2.svg" class="nl__conf nl__conf__2">
        <img src="/static/img/gus_1.svg" class="nl__conf nl__conf__3">
        <div class="conf__smallring nl__conf nl__conf__4"></div>
        <div class="conf__dot nl__conf nl__conf__5"></div>
        <div class="conf__smallring nl__conf nl__conf__6"></div>
        <div class="conf__dot nl__conf nl__conf__7"></div>
      </div>
      <div class="popup__bottom">
        <p class="popup__bottom__about">
          <span class="popup__bottom__link">Подробнее о программе лояльности</span>
        </p>
        <div class="popup__bottom__button">Закрыть</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {}
</script>




// WEBPACK FOOTER //
// next-lvl-achieved.vue?aa4b1104